// extracted by mini-css-extract-plugin
export var alternate = "_1l-j";
export var black = "_1l-6";
export var blue = "_1l-f";
export var blueLight = "_1l-e";
export var brand = "_1l-8";
export var darkMode = "_1l-b";
export var error = "_1l-a";
export var gray = "_1l-5";
export var grayBlue = "_1l-d";
export var iconWrapper = "_1l-3";
export var inactive = "_1l-7";
export var indigo = "_1l-g";
export var orange = "_1l-i";
export var pink = "_1l-h";
export var primary = "_1l-0";
export var purple = "_1l-9";
export var success = "_1l-4";
export var warning = "_1l-c";
export var white = "_1l-1";
export var whiteSuccess = "_1l-2";